export enum TransferTypes {
  CASH_IN = 'CASH IN',
  CASH_OUT = 'CASH OUT',
  DISBURSEMENT = 'DISBURSEMENT'
}
